module.exports = __webpack_public_path__ + "img/marine_app_3.84429f5d.jpg";